import { useRootStore } from 'stores/RootStore'
import { useFlipperFlag } from './useFlipperFlag'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'

export const usePioneerCredits = () => {
  const isPioneerCreditsEnabled = useFlipperFlag('pioneer_credits')
  const {
    tierUsageStore: { currentSubscription },
    creditUsageStore: { creditUsage },
  } = useRootStore()

  return (
    isPioneerCreditsEnabled &&
    currentSubscription?.plan === PaymentPlanKey.VirtualMarketer &&
    currentSubscription?.status === 'active' &&
    creditUsage &&
    Object.keys(creditUsage).length > 0
  )
}
